import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./pages/AuthContext";
import Login from "./pages/Login";
import ProtectedRoute from "./pages/ProtectedRoute";
import { DarkModeProvider } from "./utils/DarkModeProvider";
import { GlobalProvider } from "./utils/GlobalContext";
import Formulario from "./pages/Formulario";
import Home from "./pages/Home";
import GetToken from "./pages/GetToken";
const root = ReactDOM.createRoot(document.getElementById("root"));
import LoginSAML from "./pages/LoginSAML";
import ResumenInstancias from "./pages/ResumenInstancias";

root.render(
	// <React.StrictMode>
		<BrowserRouter>
			<AuthProvider>
				< DarkModeProvider >
					<Routes>
						<Route path="/" element={<LoginSAML />} />
						<Route path="/login/usuario" element={<Login />} />
						<Route path="/evaluador" element={<Login />} />
						<Route path="/auth/callback/login/:token" element={<GetToken />} />
						<Route path="/home" element={<ProtectedRoute><GlobalProvider><Home /></GlobalProvider></ProtectedRoute>} />
						<Route path="/formulario" element={<ProtectedRoute><GlobalProvider><Formulario /></GlobalProvider></ProtectedRoute>} />
						<Route path="/resumen" element={<ProtectedRoute><GlobalProvider><ResumenInstancias /></GlobalProvider></ProtectedRoute>} />
					</Routes>
				</DarkModeProvider>
			</AuthProvider>
		</BrowserRouter>
	// </React.StrictMode>
)